import crud from './crud'
import credentials from './credentials'
import serviceAccountRoles from './serviceAccountRoles'
import scopes from './scopes'

export default {
    namespaced: true,
    state: {
        ...crud.state,
        ...credentials.state,
        ...serviceAccountRoles.state,
        ...scopes.state,
    },
    mutations: {
        ...crud.mutations,
        ...credentials.mutations,
        ...serviceAccountRoles.mutations,
        ...scopes.mutations
    },
    actions: {
        ...crud.actions,
        ...credentials.actions,
        ...serviceAccountRoles.actions,
        ...scopes.actions
    }
}